import axios from "axios";

// เปลี่ยนเป็น port 8000
const API_URL = "https://asc.sskru.ac.th/backend/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

// Stats API
export const statsAPI = {
  getDashboard: () => api.get("/stats.php"),
  updateVisitor: () => api.post("/stats.php?action=visitor"),
  getBudgetChart: () => api.get("/stats.php?action=budget-chart"),
};

export const knowledgeAPI = {
  getAll: (params) => {
    const cleanParams = {};

    // page และ limit ส่งเสมอ
    cleanParams.page = params.page || 1;
    cleanParams.limit = params.limit || 12;

    // search: ส่งเฉพาะเมื่อมีค่า
    if (params.search && params.search.trim() !== "") {
      cleanParams.search = params.search.trim();
    }

    // category: ส่งเฉพาะเมื่อมีค่าและไม่ใช่ค่าว่าง
    // ถ้าเป็น "ทั้งหมด" จะส่งค่าว่างไป ซึ่ง backend ควรไม่ใส่เงื่อนไข category
    if (params.category && params.category !== "") {
      cleanParams.category = params.category;
    }

    console.log("API Request params:", cleanParams);

    return api.get("/knowledge.php", { params: cleanParams });
  },

  getRecent: (limit) => {
    // ใช้ endpoint เฉพาะสำหรับ recent โดยเฉพาะ
    return api.get(`/knowledge.php?action=recent&limit=${limit}`);
  },

  getById: (id) => api.get(`/knowledge.php?id=${id}`),
  getByCategory: (categoryId, params) =>
    api.get(`/knowledge.php?category=${categoryId}`, { params }),
  updateView: (id) => api.post("/knowledge.php?action=view", { id }),

  rate: (id, rating) => {
    console.log("Calling rate API with:", { id, rating });
    return api.post("/knowledge.php?action=rate", { id, rating });
  },
};

// Categories API
export const categoryAPI = {
  getAll: () => api.get("/categories.php"),
  getById: (id) => api.get(`/categories.php?id=${id}`),
};

// Projects API
export const projectAPI = {
  getAll: (params) => api.get("/projects.php", { params }),
  getById: (id) => {
    console.log("Fetching project with ID:", id);
    return api.get(`/projects.php?id=${id}`);
  },
  getLocations: () => api.get("/projects.php?action=locations"),
};

// News API
export const newsAPI = {
  getAll: (params) => api.get("/news.php", { params }),
  getById: (id) => {
    console.log("Fetching news with ID:", id);
    return api.get(`/news.php?id=${id}`);
  },
  getRecent: (limit) => api.get(`/news.php?action=recent&limit=${limit}`),
};

// Auth API
export const authAPI = {
  getCsrfToken: () => api.get("/auth.php?action=csrf"),
  login: (data) => api.post("/auth.php?action=login", data),
  register: (data) => api.post("/auth.php?action=register", data),
  logout: () => api.post("/auth.php?action=logout"),
  getCurrentUser: () => api.get("/auth.php?action=me"),
};

// Departments API
export const departmentAPI = {
  getAll: () => api.get("/departments.php"),
  getById: (id) => api.get(`/departments.php?id=${id}`),
};

export default api;
